import { render, staticRenderFns } from "./MindfulAssesment.vue?vue&type=template&id=25bd3354&scoped=true&"
import script from "./MindfulAssesment.vue?vue&type=script&lang=js&"
export * from "./MindfulAssesment.vue?vue&type=script&lang=js&"
import style0 from "./MindfulAssesment.vue?vue&type=style&index=0&id=25bd3354&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bd3354",
  null
  
)

export default component.exports